/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Perks_Trigger_Invites_OneInputs */



/**
* | output |
* | --- |
* | "{count} member brought in" |
*
* @param {Perks_Trigger_Invites_OneInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_invites_one = /** @type {((inputs: Perks_Trigger_Invites_OneInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_Invites_OneInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} приглашённый участник`)
	return /** @type {LocalizedString} */ (`${i?.count} member brought in`)
});